import axios from 'axios';
import * as types from './ShoppingCart.types';
import * as selectors from './ShoppingCart.selectors';
import { showNotification } from './../../utils';
import * as loginSelectors from './../Login/Login.selectors';
import * as loginActions from './../Login/Login.actions';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchItems = () => (dispatch, getState) => {
    const cxmlData = loginSelectors.getCxmlData(getState());

    dispatch({ type: types.FETCH_ITEMS, payload: null });
    axios.get(apiUrl + '/uthealth-shopping-cart-items?cxml=' + cxmlData.id,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_ITEMS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_ITEMS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const checkout = () => (dispatch, getState) => {
    const user = loginSelectors.getUser(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());
    const platformType = loginSelectors.getPlatformType(getState());
    const shippingType = selectors.getShippingType(getState());

    var formData = new FormData();
    formData.append('userId', user.id);
    formData.append('orderType', 2);

    formData.append('shipName', '');
    formData.append('shipAddress1', '');
    formData.append('shipAddress2', '');
    formData.append('shipCity', '');
    formData.append('shipState', '');
    formData.append('shipZip', '');
    formData.append('shipPhone', '');
    formData.append('shipEmail', '');
    formData.append('shipNotes', '');
    formData.append('billName', '');
    formData.append('billAddress1', '');
    formData.append('billAddress2', '');
    formData.append('billCity', '');
    formData.append('billState', '');
    formData.append('billZip', '');
    formData.append('billPhone', '');
    formData.append('billEmail', '');
    formData.append('billPo', '');
    formData.append('billDepartment', '');
    formData.append('billCall', '');
    formData.append('billNotes', '');

    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);
    formData.append('platformType', platformType);
    formData.append('shippingType', shippingType);

    dispatch({ type: types.CHECKOUT, payload: null });
    axios.post(apiUrl + '/uthealth-order/place-order', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CHECKOUT_SUCCESS, payload: response.data });
            showNotification('Success', 'The order has been created successfully', 'success');
            document.getElementById('cxml-urlencoded').value = response.data.cxml;
            document.getElementById('cxml-form').submit();
        })
        .catch((error) => {
            dispatch({ type: types.CHECKOUT_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const changeQuantity = (id, quantity) => (dispatch, getState) => {
    dispatch({ type: types.CHANGE_QUANTITY, payload: id });
    axios.post(apiUrl + '/uthealth-shopping-cart-item/change-quantity', { id, quantity },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CHANGE_QUANTITY_SUCCESS, payload: { id, item: response.data } });
        })
        .catch((error) => {
            dispatch({ type: types.CHANGE_QUANTITY_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const deleteItem = (id) => (dispatch, getState) => {
    dispatch({ type: types.DELETE_ITEM, payload: null });
    axios.delete(apiUrl + '/uthealth-shopping-cart-items/' + id,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.DELETE_ITEM_SUCCESS, payload: response.data });
            dispatch(fetchItems());
        })
        .catch((error) => {
            dispatch({ type: types.DELETE_ITEM_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const editProduct = (id, history) => (dispatch, getState) => {
    const cxmlData = loginSelectors.getCxmlData(getState());
    const user = loginSelectors.getUser(getState());

    let formData = new FormData();
    formData.append('id', id);
    formData.append('userId', user.id);
    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);

    dispatch({ type: types.EDIT_PRODUCT, payload: null });
    axios.post(apiUrl + '/uthealth-order/edit-product', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.EDIT_PRODUCT_SUCCESS, payload: response.data });
            if (response.data.url !== '') {
                const variables = response.data.variables;
                localStorage.setItem('variables', JSON.stringify(variables));
                localStorage.setItem('productType', response.data.productType);
                localStorage.setItem('quantity', response.data.quantity);
                localStorage.setItem('apparelItem', JSON.stringify(response.data.apparelItem));
                localStorage.setItem('department', JSON.stringify(response.data.department));
                localStorage.setItem('url', response.data.url);
                localStorage.setItem('id', id);

                history.push(response.data.url + '/edit');
            } else {
                showNotification('Item not found', 'This item does not exists anymore.', 'info');
            }
        })
        .catch((error) => {
            dispatch({ type: types.EDIT_PRODUCT_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const checkoutItem = (id, value) => (dispatch, getState) => {
    dispatch({ type: types.CHECKOUT_ITEM, payload: { id, value } });
    axios.put(apiUrl + '/uthealth-shopping-cart-items/' + id, { checkout: value },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CHECKOUT_ITEM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.CHECKOUT_ITEM_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}

export const changeItemQuantity = (index, value) => (dispatch) => {
    dispatch({
        type: types.CHANGE_ITEM_QUANTITY,
        payload: { index, value },
    })
}

export const setShippingType = (value) => (dispatch) => {
    localStorage.setItem('shippingType', value);
    dispatch({
        type: types.SET_SHIPPING_TYPE,
        payload: value,
    })
}